import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomTextArea,
} from '../../../common/components';

const ConstructionTypeDialog = ({ open, onClose, onSave, selectedItem, editMode }) => {
  const [formData, setFormData] = useState({
    name: '',
    surface: '',
    description: '',
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open) {
      setFormData({
        name: selectedItem?.name || '',
        surface: selectedItem?.surface !== undefined ? selectedItem.surface.toString() : '',
        description: selectedItem?.description || '',
      });
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = true;
    }
    if (!formData.surface) {
      newErrors.surface = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>
        {editMode ? 'Editar Tipo de construcción' : 'Agregar Tipo de construcción'}
      </DialogTitle>

      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <Box sx={{ display: 'block' }}>
            <CustomTextField
              margin="dense"
              name="name"
              label="Nombre"
              type="text"
              fullWidth
              value={formData.name}
              onChange={handleInputChange}
              error={errors.name || (saveAttempted && !formData.name)}
              helperText={
                errors.name || (saveAttempted && !formData.name) ? 'El nombre es obligatorio' : ''
              }
            />

            <CustomTextField
              margin="dense"
              name="surface"
              label="Superficie"
              type="number"
              fullWidth
              value={formData.surface}
              onChange={handleInputChange}
              error={errors.surface || (saveAttempted && !formData.surface)}
              helperText={
                errors.surface || (saveAttempted && !formData.surface)
                  ? 'La superficie es obligatoria'
                  : ''
              }
            />

            <CustomTextArea
              label={'Descripción'}
              margin="dense"
              name="description"
              placeholder="Descripción"
              multiline
              rows={3}
              fullWidth
              value={formData.description}
              onChange={handleInputChange}
            />
          </Box>
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default ConstructionTypeDialog;
